import { Component, ViewEncapsulation, HostBinding, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'inactive-status-user',
    templateUrl: 'inactive.status.user.component.html',
    styleUrls: ['inactive.status.user.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class InactiveStatusUserComponent {

    @HostBinding('class.modern-form') modern = true;
}
